import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPriority = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "m8,15c3.866,0 7,-3.134 7,-7c0,-3.86599 -3.134,-7 -7,-7c-3.86599,0 -7,3.13401 -7,7c0,3.866 3.13401,7 7,7zm-0.66667,-8.44667l0,5.44667l1.33334,0l0,-5.44667l2.39333,2.38667l0.94,-0.94l-4,-4l-4,4l0.94,0.94l2.39333,-2.38667z",
		fillRule: "evenodd"
	})
});
export default SvgPriority;
